import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { connect } from 'react-redux';

import { Spacer } from '@zillow/constellation';
import {
    Col,
    HR,
    Row,
} from '@zillow/zrs-comet';

import { PropertiesSelectors } from 'app/shared/selectors';
import LeadGuaranteeBanner from 'app/shared/components/postingPath/LeadGuaranteeBanner';
import {
    StyledListingOverview,
    StyledText,
    StyledTriangle,
} from './StyledComponents';

// TODO: refactor to be a component for ListingStatus col also
const OverviewCol = (props) => {
    const { title, children } = props;

    return (
        <div className="Published-Col Overview-Col">
            <StyledText as="div" fontType="bodySmall">{title}</StyledText>
            <StyledText
                as="div"
                bold={true}
                fontType="body"
            >
                {children}
            </StyledText>
        </div>
    );
};

const PaidInclusionOverview = ({
    currentProperty,
}) => {
    const title = 'Overview';
    const {
        autoBillEnabled,
        dateLastActivated,
        expirationDate: dateToExpire,
        numLeadsSinceLastActivated = 0,
        isEligible: isEligibleForLeadGuarantee,
    } = currentProperty;

    const formattedDateLastActivated = dateLastActivated ? format(new Date(dateLastActivated), 'MMM DD') : '-';
    const renewOrExpireTitle = autoBillEnabled ? 'Renews' : 'Expires';
    const formattedDateToExpire = dateToExpire ? format(dateToExpire, 'MMM DD') : '-';

    const renderLeadGuaranteeBanner = () => {
        const heading = 'Lead Guarantee';
        const body = `Your renewal will be free if you don’t get any leads by ${formattedDateToExpire}`;
        const actionLabel = 'Check out our help article on getting more renter interest';
        const actionPath = 'https://help.zillowrentalmanager.com/hc/en-us/articles/360048462014';

        return (
            <Spacer marginBottom="sm">
                <LeadGuaranteeBanner
                    heading={heading}
                    body={body}
                    actionLabel={actionLabel}
                    actionPath={actionPath}
                    actionTarget="_blank"
                />
            </Spacer>
        );
    };

    const renderBaseColumns = () => (
        <React.Fragment>
            <OverviewCol title="Published" data-test="published-col">{formattedDateLastActivated}</OverviewCol>
            <OverviewCol title="Inquiries" data-test="inquires-col">{numLeadsSinceLastActivated}</OverviewCol>
            <OverviewCol title={renewOrExpireTitle} data-test="expiration-col">{formattedDateToExpire}</OverviewCol>
        </React.Fragment>
    );

    const renderLeadGuaranteeColumns = () => (
        <React.Fragment>
            <OverviewCol title="Inquiries" data-test="inquires-col">
                <StyledTriangle />
                <div>{numLeadsSinceLastActivated}</div>
            </OverviewCol>
            <OverviewCol title="Published" data-test="published-col">{formattedDateLastActivated}</OverviewCol>
            <OverviewCol title={renewOrExpireTitle} data-test="expiration-col">{formattedDateToExpire}</OverviewCol>
        </React.Fragment>
    );

    const renderColumns = isEligibleForLeadGuarantee ? renderLeadGuaranteeColumns : renderBaseColumns;

    return (
        <StyledListingOverview className="PaidInclusionOverview">
            <Row>
                <Col>
                    <div>
                        <StyledText
                            marginBottom="xs"
                            mediaQuery={{
                                lg: {
                                    marginBottom: 'sm',
                                },
                            }}
                            as="div"
                            fontType="h4"
                        >
                            {title}
                        </StyledText>
                        <HR className="HR-Divider HR-Divider--top" />

                        {isEligibleForLeadGuarantee && renderLeadGuaranteeBanner()}

                        <div className="Overview-Container">
                            {renderColumns()}
                        </div>
                        <HR className="HR-Divider HR-Divider--bottom" />
                    </div>
                </Col>
            </Row>
        </StyledListingOverview>
    );
};

PaidInclusionOverview.propTypes = {
    currentProperty: PropTypes.shape({
        autoBillEnabled: PropTypes.bool.isRequired,
        dateLastActivated: PropTypes.string.isRequired,
        dateToExpire: PropTypes.string.isRequired,
        isEligible: PropTypes.bool,
    }).isRequired,
};

const mapStateToProps = state => ({
    currentProperty: PropertiesSelectors.makeCurrentProperty(state),
});

export { PaidInclusionOverview };
export default connect(mapStateToProps)(PaidInclusionOverview);
